import { render } from "./Cookies.vue?vue&type=template&id=7b993eec&scoped=true&ts=true"
import script from "./Cookies.vue?vue&type=script&lang=ts"
export * from "./Cookies.vue?vue&type=script&lang=ts"

import "./Cookies.vue?vue&type=style&index=0&id=7b993eec&scoped=true&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\Renault\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b993eec"]])

export default __exports__